import { ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS } from '../../control_estudios/asistencias/AsistenciasReducer';
import {
  ACTIVO_NOTAS_BLOPED,
  ALL_ESTUDIANTES_PLAN_NOTAS_BLOPED,
  ALL_NOTAS_BLOPED,
  IS_DISABLED_DATA,
  LOADING_ALL_NOTAS_BLOPED,
} from './NotasBlopedReducer';
import {
  allEstudiantesNotasBlopedService,
  allEstudiantesPlanNotasBlopedService,
  allNotasBlopedService,
  oneNotasBlopedService,
  saveNotasBlopedService,
} from './NotasBlopedService';

export const allNotasBlopedAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: true });
    const res = await allNotasBlopedService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_NOTAS_BLOPED, payload: res.data });
      dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
  }
};

export const allEstudiantesNotasBlopedAction = async (
  dispatch,
  params,
  setEmptyData,
) => {
  try {
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: true });
    const res = await allEstudiantesNotasBlopedService(params);
    if (res.status === 200) {
      if (setEmptyData) {
        dispatch({ type: ALL_ESTUDIANTES_PLAN_NOTAS_BLOPED, payload: [] });
        dispatch({ type: ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS, payload: [] });
        dispatch({ type: IS_DISABLED_DATA, payload: false });
      }
      dispatch({ type: ALL_NOTAS_BLOPED, payload: res.data });
      dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
  }
};

export const saveNotasBlopedAction = async (dispatch, id, data, params) => {
  try {
    const res = await saveNotasBlopedService(id, data);
    const success = res.status >= 200 && res.status < 203;
    if (success) {
      await allEstudiantesNotasBlopedAction(dispatch, params, false);
      // alertNotasBloped(dispatch, ALERT_VIEW_NOTAS_BLOPED, {
      //   severity: 'success',
      //   title: res.data.message,
      // });
    } else {
      // alertNotasBloped(dispatch, ALERT_FORM_NOTAS_BLOPED, {
      //   severity: 'error',
      //   title: 'Error al momento de registrar La materia',
      // });
    }
    return success;
  } catch (e) {
    // alertNotasBloped(dispatch, ALERT_FORM_NOTAS_BLOPED, {
    //   severity: 'error',
    //   title: e.response?.data.message ?? e.message,
    // });
  }
};

export const setActivoNotasBlopedAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_NOTAS_BLOPED, payload: data });
};

export const oneNotasBlopedAction = async (dispatch, idEntidad, id) => {
  const res = await oneNotasBlopedService(idEntidad, id);
  if (res.status === 200) {
    await setActivoNotasBlopedAction(dispatch, res.data);
    return true;
  }
  return false;
};

export const deleteNotasBlopedAction = async (
  dispatch,
  idEntidad,
  id,
  params,
  setLoadingDelete,
) => {
  // try {
  //   setLoadingDelete(true);
  //   const res = await deleteNotasBlopedService(idEntidad, id);
  //   if (res.status === 200) {
  //     await setActivoNotasBlopedAction(dispatch, null);
  //     setLoadingDelete(false);
  //     await allNotasBlopedAction(dispatch, idEntidad, params);
  //     alertNotasBloped(dispatch, ALERT_VIEW_NOTAS_BLOPED, {
  //       severity: "info",
  //       title: res.data.message ?? "Sección eliminada exitosamente",
  //     });
  //     return true;
  //   }
  //   setLoadingDelete(false);
  //   alertNotasBloped(dispatch, ALERT_VIEW_NOTAS_BLOPED, {
  //     severity: "error",
  //     title: res.data.message ?? "Error al momento de eliminar La sección",
  //   });
  //   return false;
  // } catch (e) {
  //   setLoadingDelete(false);
  //   alertNotasBloped(dispatch, ALERT_VIEW_NOTAS_BLOPED, {
  //     severity: "error",
  //     title: e.response?.data.message ?? e.message,
  //   });
  // }
};

export const allEstudiantesPlanNotasBlopedAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: true });
    const res = await allEstudiantesPlanNotasBlopedService(params);
    if (res.status === 200) {
      dispatch({
        type: ALL_ESTUDIANTES_PLAN_NOTAS_BLOPED,
        payload: res.data.data,
      });
      dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_NOTAS_BLOPED, payload: false });
  }
};
